module.exports = __webpack_public_path__ + "img/Login-carousal-1.883b1ee4.svg";